'use client';

import { createContext } from 'react';
import type { RefObject } from 'react';
import type { CommandMenuSize } from './command-menu.types';

type CommandMenuContextValue = {
    size: CommandMenuSize;
    menuRef?: RefObject<HTMLDivElement | null>;
};

export const CommandMenuContext = createContext<CommandMenuContextValue>({
    size: 'sm',
});
